import { ReactNode } from "react";
import { FlowioInputType, SOR, TemplateId } from "src/globalTypes";
import { Table, TableCellValue, TableColumns } from "src/requests/table/types";
import { OverviewTablesByTemplateId } from "src/store/overviewTables/types";

export enum OnlyCSVExtensionsEnum {
  excel = "xlsx",
  csv = "csv",
}

export enum TableExtensionsEnum {
  excel = "xlsx",
  csv = "csv",
  pdf = "pdf",
}

export type ExtensionsType = OnlyCSVExtensionsEnum | TableExtensionsEnum;

export enum ExportOptions {
  table = "table",
  tableDetail = "tableDetail",
  detail = "detail",
}

export type ExportCell = {
  key: string;
  value: string;
};

export type ExportRow = ExportCell[];

export type ExportTable = ExportRow[];

export type CSVData = string[][];

export type ExportTableToCsvParams = {
  fileName: string;
  fileExtension: OnlyCSVExtensionsEnum;
  numberOfPages: number;
  visibleColumnIds: string[];
  exportOption?: ExportOptions;
};

export type ExportTableToCsv = (
  params: ExportTableToCsvParams
) => Promise<void>;

export type GetOverviwTablesForTemplateIds = (
  templateIds: number[]
) => OverviewTablesByTemplateId;

type ExportTableReturn = {
  exportSuccess: boolean;
  isLoading: boolean;
  exportTable: ExportTableToCsv;
};

export type UseExportTable = (
  templateId: TemplateId,
  fulltextQuery: string,
  sor: SOR,
  onSuccess?: () => void
) => ExportTableReturn;

export type FormProps = {
  fileName: string;
  fileExtension: OnlyCSVExtensionsEnum;
  numberOfPagesToExport?: number;
  exportAllPages?: boolean;
  exportOption?: ExportOptions;
};

export interface TableExportFormProps {
  totalRowsCount: number;
  rowsPerPageCount: number;
  templateName: string;
  exportSuccess: boolean;
  exportTable: ExportTableToCsv;
  tableColumns: TableColumns;
  onSuccess: () => void;
}

export type FilteredColumnsWithModal = {
  visibleColumnIds: string[];
  toggleModal(): void;
  modal: ReactNode;
};
export type VisibleColumnsIds = Record<string, boolean>;

export type TableDataByColumn = Record<string, Table>;

export type ColKeysByOverviewTemplateId = Record<number, string>;

export type TableCellValusByColKey = Record<string, TableCellValue>;

export type ExportRowValues = Record<string, string>;

export type FormatMetadataRelatedValue = (
  value: string,
  colGroup: number,
  type?: FlowioInputType
) => string;

export type RowsAndColsCount = {
  rowsCount: number;
  colsCount: number;
};

export const isOnlyCsvExtension = (
  fileExtension: ExtensionsType
): fileExtension is OnlyCSVExtensionsEnum =>
  fileExtension !== TableExtensionsEnum.pdf;

export type TableCellLinkType = {
  linkValue: string;
  flowioLink: string;
};
